

export default function HowToGetThere() {
  const steps = [
    {
      number: '1',
      icon: 'ri-plane-line',
      title: 'Lot do Teneryfy',
      description: 'Loty z Polski do Teneryfy Południowej (TFS) – regularne połączenia z Warszawy, Krakowa i innych miast.'
    },
    {
      number: '2',
      icon: 'ri-car-line',
      title: 'Transfer do portu',
      description: 'Z lotniska do portu Los Cristianos – około 20 minut jazdy samochodem, taksówką lub autobusem.'
    },
    {
      number: '3',
      icon: 'ri-ship-line',
      title: 'Prom na La Gomerę',
      description: 'Przeprawa promem Fred Olsen – malownicza podróż przez ocean (około 50 minut).'
    },
    {
      number: '4',
      icon: 'ri-map-pin-line',
      title: 'Dojazd do hotelu',
      description: 'Z portu San Sebastián do Hotel Jardín Tecina – około 30 minut jazdy. Dostępne taksówki i wynajem samochodów.'
    }
  ];

  return (
    <section id="dojazd" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            Jak dotrzeć
          </h2>
          <div className="w-24 h-1 bg-stone-300 mx-auto mb-8"></div>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Dojazd do Hotel Jardín Tecina jest prosty i dobrze zorganizowany. Poniżej znajdziesz informacje o logistyce – od lotu po dojazd do hotelu.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step) => (
            <div key={step.number} className="text-center">
              <div className="relative mb-6">
                <div className="w-20 h-20 flex items-center justify-center bg-stone-800 text-white rounded-full mx-auto mb-4 text-2xl font-light">
                  {step.number}
                </div>
                <div className="w-16 h-16 flex items-center justify-center bg-stone-100 rounded-full mx-auto">
                  <i className={`${step.icon} text-stone-700 text-2xl`}></i>
                </div>
              </div>
              <h3 className="text-xl font-medium text-stone-800 mb-3">{step.title}</h3>
              <p className="text-stone-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
        
        <div className="bg-stone-50 rounded-lg p-8 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
            <i className="ri-customer-service-2-line text-green-700 text-2xl"></i>
          </div>
          <h3 className="text-2xl font-medium text-stone-800 mb-4">Wsparcie logistyczne dla agencji</h3>
          <p className="text-stone-600 leading-relaxed max-w-2xl mx-auto mb-6">
            Pomagamy w koordynacji całej logistyki: rozkłady promów, informacje o transferach, rezerwacje i wsparcie operacyjne. Skontaktuj się z nami, aby uzyskać szczegółowe informacje.
          </p>
          <a
            href="#kontakt"
            className="inline-block px-8 py-3 bg-stone-800 text-white font-medium rounded-md hover:bg-stone-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Zapytaj o wsparcie logistyczne
          </a>
        </div>
      </div>
    </section>
  );
}